module.exports = __webpack_public_path__ + "static/media/AvertaStd-Bold.4d803545.woff2";